export default __webpack_public_path__ + "static/media/04.324c5cbb.webp";